import * as _ from 'underscore';

import { ISettingsCoordinatorCtrlScope, SettingsFormService } from '../../settings/directives/tbSettingsCoordinator';
import { IGetTimeZonesResult, TimeZones } from '../../userSettings/services/TimeZones';
import { Module } from '../Module';
import { ITimeZone } from '../ServerApi/types/ITimeZone';

export interface ITimeZoneSiteSettingScope extends ISettingsCoordinatorCtrlScope {
  timeZoneId: string;
  fullTimeZoneList: ITimeZone[];
  model: { timeZoneId: string };
  useDefaultTimeZone: boolean;
}

const initDefaultTimeZone = ($scope: ITimeZoneSiteSettingScope) => {
  $scope.model = {
    timeZoneId: $scope.timeZoneId,
  };
};

const noop = () => { };
const submitChange = ($scope: ITimeZoneSiteSettingScope): ng.IPromise<any> => {
  $scope.model = {
    timeZoneId: $scope.timeZoneId
  };
  return;
};

export class TimeZoneSiteSettingCtrl {

  public static $inject = [
    '$scope',
    '$q',
    'SettingsFormService'
  ];
  $onInit: () => void;

  constructor(
    private $scope: ITimeZoneSiteSettingScope,
    $q: ng.IQService,
    formService: SettingsFormService
  ) {
    this.$onInit = () => {
      initDefaultTimeZone($scope);

      $scope.sharedForm = formService;
      $scope.localForm = {
        formController: {
          $pristine: true,
          $dirty: false,
          $valid: true,
          $invalid: true,
          $submitted: false,
          $error: {},
          $addControl: noop,
          $removeControl: noop,
          $setValidity: noop,
          $setDirty: noop,
          $setPristine: noop,
          $setSubmitted: noop,
          $setUntouched: noop,
          $commitViewValue: noop,
          $rollbackViewValue: noop,
        },
        save: () => submitChange($scope),
        cancel: () => { },
        isBusy: () => false,
        isFormUnchanged: () => {
          if ($scope.timeZoneId !== undefined && $scope.timeZoneId !== '') {
            $scope.useDefaultTimeZone = false;
          } else {
            $scope.useDefaultTimeZone = true;
          }
          return $scope.model.timeZoneId === $scope.timeZoneId;
        },
        isValid: () => true,
      };

      TimeZones.getAll().then((result: IGetTimeZonesResult) => {
        result.fullTimeZonesList.unshift({
          displayName: '',
          timeZoneId: '',
          timeZoneRawOffsetMinutes: 0
        });
        $scope.fullTimeZoneList = result.fullTimeZonesList;
      });
    };
  }
}

Module.instance().controller('TimeZoneSiteSettingCtrl', TimeZoneSiteSettingCtrl);
